import { isAppTypeCourtRental } from './appTypeSettings';

const COLORS = [
  { id: 1, base: '#19ff90', header: '#15d679', text: 'black', textLight: '#333333' },
  { id: 2, base: '#3DD2FF', header: '#00ade2', text: 'black', textLight: '#333333' },
  { id: 3, base: '#FF7FAA', header: '#FE4582', text: 'black', textLight: '#333333' },
  { id: 4, base: '#F7DD69', header: '#e2b800', text: 'black', textLight: '#333333' },
  { id: 5, base: '#E17FFF', header: '#D64EFF', text: 'black', textLight: '#333333' },
  { id: 7, base: '#ffa300', header: '#E39000', text: 'black', textLight: '#333333' },
  { id: 8, base: '#FF48B3', header: '#D9288F', text: 'black', textLight: '#333333' },
  { id: 9, base: '#8000ff', header: '#6600CC', text: 'white', textLight: '#f7f7f7' },
  { id: 10, base: '#800040', header: '#97004B', text: 'white', textLight: '#f7f7f7' },
  { id: 6, base: '#000000', header: '#292828', text: 'white', textLight: '#f7f7f7' },

  { id: 11, base: '#89fc00', header: '#76D600', text: 'black', textLight: '#333333' },
  { id: 12, base: '#3C55FE', header: '#1131FE', text: 'white', textLight: '#f7f7f7' },
  { id: 13, base: '#DB00B6', header: '#BC009D', text: 'white', textLight: '#f7f7f7' },
  { id: 14, base: '#C9A227', header: '#AD8C21', text: 'black', textLight: '#333333' },
  { id: 15, base: '#D90429', header: '#B80422', text: 'white', textLight: '#f7f7f7' },
  { id: 16, base: '#FB5607', header: '#DC4803', text: 'black', textLight: '#333333' },
  { id: 17, base: '#AF2FF4', header: '#9E0CED', text: 'white', textLight: '#f7f7f7' },

  { id: 18, base: '#06d6a0', header: '#05B788', text: 'black', textLight: '#333333' },
  { id: 19, base: '#ffc300', header: '#DBA800', text: 'black', textLight: '#333333' },
  { id: 20, base: '#7fc8f8', header: '#4EB3F6', text: 'black', textLight: '#333333' },
  { id: 21, base: '#c2f0a5', header: '#9FE772', text: 'black', textLight: '#333333' },
  { id: 22, base: '#efebce', header: '#DFD89D', text: 'black', textLight: '#333333' },
  { id: 23, base: '#fec89a', header: '#FDAA60', text: 'black', textLight: '#333333' },
  { id: 24, base: '#e2afff', header: '#CB70FF', text: 'black', textLight: '#333333' },
  { id: 25, base: '#EFBCD5', header: '#E38CB6', text: 'black', textLight: '#333333' },
];
const ICONS = [
  'paintbrush',
  'dumbbell',
  'scissors',
  'stethoscope',
  'tooth',
  'syringe',
  'guitar',
  'microphone-lines',
  'hands',
  'hammer',
  'briefcase',
  'camera',
  'video',
  'pencil',
  'book',
  'baseball',
  'sun',
  'champagne-glasses',
  'table-tennis-paddle-ball',
  'car',
  'paw',
];
const ICONS_COURT_RENTAL = [
  'tennis-ball',
  'racquet',
  'futbol',
  'volleyball',
  'table-tennis-paddle-ball',
  'whistle',
  'dumbbell',
  'briefcase',
];

const COLORS_INDEX = COLORS.reduce((obj, item) => {
  // eslint-disable-next-line no-param-reassign
  obj[item.id] = item;
  return obj;
}, {});

export const getAgendaColor = (colorId) => {
  if (colorId) {
    return COLORS_INDEX[colorId];
  }
  return COLORS[0];
};

export const getAgendaColorOrNull = (colorId) => {
  if (colorId) {
    return COLORS_INDEX[colorId];
  }
  return null;
};

function getAdjustedLegacyAgendaIcon(agendaIcon) {
  if (agendaIcon === 'paint-brush') {
    return 'paintbrush';
  }
  if (agendaIcon === 'cut') {
    return 'scissors';
  }
  if (agendaIcon === 'microphone-alt') {
    return 'microphone-lines';
  }
  if (agendaIcon === 'pencil-alt') {
    return 'pencil';
  }
  if (agendaIcon === 'baseball-ball') {
    return 'baseball';
  }
  if (agendaIcon === 'glass-cheers') {
    return 'champagne-glasses';
  }
  if (agendaIcon === 'table-tennis') {
    return 'table-tennis-paddle-ball';
  }
  return agendaIcon;
}

const getIcons = () => {
  const isCourtRental = isAppTypeCourtRental();
  return isCourtRental ? ICONS_COURT_RENTAL : ICONS;
};

export const getAgendaIcon = (agendaIcon) => {
  const icons = getIcons();
  if (agendaIcon) {
    const adjustedAgendaIcon = getAdjustedLegacyAgendaIcon(agendaIcon);
    const selectionIndex = icons.indexOf(adjustedAgendaIcon);
    if (selectionIndex !== -1) {
      return icons[selectionIndex];
    }
  }
  return icons[0];
};

export { getIcons, COLORS };
